<template>
  <v-chip
    label
    color="blue-darken-3"
    theme="dark"
    class="px-1"
    :size="isDense ? 'x-small' : 'small'"
    v-bind="$attrs"
  >
    <base-picture-contact-avatar
      v-if="linkedin && linkedin.profile"
      :src="(linkedin.profile.picture) ? linkedin.profile.picture : ''"
      class="mr-1"
      :width="(isDense) ? 16 : 22"
      :height="(isDense) ? 16 : 22"
    ></base-picture-contact-avatar>
    <span
      v-if="linkedin && linkedin.username"
    >{{ (linkedin.username.length > maxLength) ? linkedin.username.substring(0, (maxLength - 2)) + "..." : linkedin.username }}</span>
    <v-icon
      v-if="linkedin"
      class="ml-1"
      :size="isDense ? 'x-small' : 'small'"
    >mdi-linkedin</v-icon>
  </v-chip>
</template>

<script>
export default {
  name: 'BaseLinkedinAccount',

  inheritAttrs: false,

  props: {
    modelValue: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    density: {
      type: String,
      default: undefined,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue', 'input'],

  computed: {
    linkedin() {
      return this.modelValue ?? this.value;
    },
    isDense() {
      return this.dense || this.density === 'compact';
    },
    maxLength: function () {
      return (this.narrow) ? 20 : 25;
    },
  },

  watch: {
    linkedin() {
      this.$emit('update:modelValue', this.linkedin);
      this.$emit('input', this.linkedin);
    },
  },
};
</script>
